/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Flex, Text, useThemeUI, Button } from '@tishman/components';
import React from 'react';

export const TicketsErrorModal = (): React.JSX.Element => {
  const { theme } = useThemeUI();

  return (
    <Flex
      data-close-exit-modal
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10,
        backgroundColor: theme.colors.backgroundOverlay,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Flex
        sx={{
          bg: 'modalBackground',
          width: '28.5rem',
          height: '17.75rem',
        }}
      >
        <Flex
          sx={{
            width: '95%',
            margin: 'auto',
            height: '16.2rem',
            border: '1px solid black',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Flex
            sx={{
              width: '95%',
              height: '14.6rem',
              border: '1px solid black',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Flex
              sx={{
                flex: 1,
                flexDirection: 'column',
                marginRight: '1rem',
                marginLeft: '1rem',
              }}
            >
              <Flex
                sx={{
                  flex: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Text sx={{ textAlign: 'center' }} variant="smallTitle">
                  The ticketing system is currently offline. Please wait a few
                  moments before refreshing your page.
                </Text>
              </Flex>
              <Flex
                sx={{
                  flex: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <Button
                  onClick={() => window.location.reload()}
                  sx={{
                    bg: 'textInverted',
                    width: 'calc(100% - 40px)',
                    border: 'none',
                    fontWeight: 'medium',
                    fontFamily: 'body',
                  }}
                >
                  Refresh Now
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
